import PublicNavbar from './PublicNavbar';
import Footer from './Footer';

// Shared wrapper for all public-facing pages, added 2026-07-10.
//
// Previously each of ~20 public pages imported PublicNavbar directly and
// rendered its own content with no <main> landmark at all — confirmed via
// Lighthouse (landmark-one-main and skip-link both failing on every public
// page tested: homepage, role pages, blog posts). The existing skip link
// in PublicNavbar/PublicNavbar's "pub-skip" anchor points at
// href="#main-content", but nothing on these pages actually had an element
// with that id, so the skip link had nothing to jump to.
//
// This also centralizes the footer (see Footer.jsx) — only 4 of the ~20
// pages had one before, each with independently duplicated, low-contrast
// markup.
export default function PublicLayout({ children, forceLight = true, hideFooter = false, hideNavbar = false }) {
  return (
    <>
      {!hideNavbar && <PublicNavbar forceLight={forceLight} />}
      <main id="main-content">{children}</main>
      {!hideFooter && <Footer />}
    </>
  );
}
